export default __webpack_public_path__ + "assets/images/aistudio/views/a20c32d73d6f4ebe06ec5e17d570b3a6.png";